import Button from './Button';

interface FormButtonsProps {
    onCancel: () => void;
    isSubmitting?: boolean;
    isDisabled?: boolean;
    disabledReason?: string;
}

/**
 * Cancelar + Guardar al pie de un formulario.
 *
 * D5 — ahora se apoya en `Button`. Antes su primario era `bg-blue-500` escrito a
 * mano: el componente que la documentación señalaba como canónico era, él mismo,
 * parte del problema que D5 viene a arreglar.
 */
export const FormButtons = ({
    onCancel,
    isSubmitting,
    isDisabled = false,
    disabledReason = 'Deshabilitado',
}: FormButtonsProps) => (
    <div className="flex justify-end space-x-4">
        <Button variant="neutral" onClick={onCancel}>
            Cancelar
        </Button>
        <Button
            type="submit"
            variant="primary"
            loading={isSubmitting}
            disabled={isDisabled}
        >
            {isSubmitting ? 'Guardando...' : isDisabled ? disabledReason : 'Guardar'}
        </Button>
    </div>
);
